/**
 *  Listener
 * **/
$(document).ready(function () {
	$(document).on('click', '[data-poll="vote"]', function () {
		VegasPoll.vote($(this));
		return false;
	});
	$(document).on('click', '.vg-poll-next .next-poll', function () {
		VegasPoll.next($(this).closest('.vg-poll'));
		return false;
	});
});

/**
 *  VG POLL
 * **/
window.VegasPoll = {
	next: function ($container) {
		$.get('/polls/next', function (data) {
			if (data.view) {
				$container.html(data.view);
			}
		});

		return false;
	},
	vote: function ($self) {
		VegasPoll.request($self, (result, $_self) => {
			if (result) {
				let $container = $_self.closest('.vg-poll-variants');

				let voted = parseInt($_self.data('voted')) + 1;
				let voted_total = parseInt($container.data('voted-total')) + 1;

				$container.attr('data-voted-total', voted_total).addClass('voted');
				$_self.attr('data-voted', voted);

				let totalSum = 0;
				$container.find('li').each(function (i, e) {
					let voted = parseInt($(e).attr('data-voted'));
					let percent = Math.abs(Math.ceil(voted / voted_total * 100));

					if (percent === Infinity) percent = 0;

					if (totalSum + percent > 100) {
						percent -= totalSum + percent - 100 + 1;
					}

					totalSum += percent;

					$(e).find('.painted').css('width', percent + '%');
					VegasPoll.counter(percent, $(this).find('.percent > span'))
				});
			}
		});
	},

	request: function ($_self, callback) {
		let params = {_token: App.csrf, id: $_self.data('id')};
		$.post('/polls/vote', params, function (data) {
			if (typeof callback == 'function') {
				callback(true, $_self);
			}
		});
	},

	counter: function (int, $target) {
		let start;
		let duration = 600;

		let step = ts => {
			if (!start) {
				start = ts;
			}

			let progress = (ts - start) / duration;
			let to = Math.abs(Math.floor(progress * int));
			if (to > 100) to = 100;
			$target.text(to);

			if (progress < 1) {
				requestAnimationFrame(step);
			}
		};

		requestAnimationFrame(step);
	}
};